import { ControlledAutocomplete } from 'Components';
import { ICriteriaStyle } from '..';
import { Avatar } from '@mui/material';
import { AccordionArrowPurple } from 'Images';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import {
  ISubSupplier,
  findResourceIdFromOptions,
  getSupplierResource,
  longestResourceOption,
} from 'Utils/suppliersResources';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export const SubCategory = ({
  autoCompleteSx,
  autoCompletePaperSx,
}: ICriteriaStyle) => {
  const { filters, setFilters, subSpecialties, dispatchSuppliers } =
    useContext(SuppliersContext);

  const isDesktop = useIsDesktop();

  const defaultValue =
    Dictionary[DICTIONARY.Suppliers].resultPage.therapy.subSpecialty;

  const optionValue = getSupplierResource(
    subSpecialties as ISubSupplier,
    filters.subSpecial
  );
  const options: string[] = [defaultValue];
  subSpecialties?.resources?.map((subSpecialty) => {
    options.push(subSpecialty.content);
    return null;
  });

  return (
    <ControlledAutocomplete
      label=''
      options={options}
      value={optionValue || defaultValue}
      setValue={(value: string) => {
        const subSpecial = findResourceIdFromOptions(
          subSpecialties as ISubSupplier,
          value
        );
        const newFilter = { ...filters, subSpecial };
        setFilters(newFilter);
        dispatchSuppliers({
          type: SUPPLIER_RESULT_FILTER.Therapy,
          payload: { value: newFilter },
        });
      }}
      style={{
        ...autoCompleteSx,
        '&&& .MuiOutlinedInput-input': {
          p: 0,
          width: `${
            (optionValue ? optionValue?.length : defaultValue?.length) + 1
          }ch`,
        },
      }}
      paperSx={{
        ...autoCompletePaperSx,
        width: `${longestResourceOption(options) + 2}ch`,
      }}
      noResultsText={Dictionary[DICTIONARY.Suppliers].resultPage.noResults}
      endAdornment={
        isDesktop ? (
          <Avatar
            alt=''
            src={AccordionArrowPurple}
            sx={{ width: '30px', height: '30px' }}
          />
        ) : null
      }
      disableClearIcon
    />
  );
};
